import { TableActionsWrapper } from '@components'

import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { TransactionsPeriodSelector } from '../TransactionsPeriodSelector'
import { TransactionsSearch } from '../TransactionsSearch'

export const TransactionsTableActions = (): ReactElement => {
  return (
    <TableActionsWrapper>
      <TransactionsSearch />
      <Space horizontal size="s8" />
      <TransactionsPeriodSelector />
    </TableActionsWrapper>
  )
}
